import React from 'react';
import styled, { css } from 'styled-components';
import {
  Grid,
  Input,
  Checkbox,
  InputLabel,
  FormControl,
} from '@material-ui/core';
import Select from 'react-select';

const Column = styled(Grid)`
  padding: 0 16px 0 0 !important;
`;

const CriteriaWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const NameWrapper = styled.div`
  flex: 2;
`;

const Name = styled.div`
  font-size: 12px;
  font-weight: bold;
  display: flex;
  align-items: center;
`;

const Spacing = styled.div`
  height: 40px;
`;

const InputWrapper = styled.div`
  flex: 3;
  display: flex;
  height: 100%;
  margin-left: auto;
  gap: 10px;
`;

const SelectWrapper = styled.div`
  flex: 3;
`;

const TextInput = styled(Input)`
  padding: 0 10px;
  height: 39px;
  margin-bottom: 2px;
  font-size: 14px !important;
  text-align: right !important;
`;

const Unit = styled.span`
  display: flex;
  align-items: center;
  padding: 0 8px;
  font-size: 14px;
`;

const Range = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
`;
const RangLabel = styled.span`
  margin-left: 5px;
  font-size: 12px;
`;

const PaperGrid = styled(Grid)`
  padding: 12px 0 12px 12px !important;
  ${props =>
    props.paperstyle === 'true'
      ? css`
          background-color: #fff;
          box-shadow: 0px 3px 5px -1px rgba(0, 0, 0, 0.2),
            0px 5px 8px 0px rgba(0, 0, 0, 0.14),
            0px 1px 14px 0px rgba(0, 0, 0, 0.12);
          border-radius: 4px;
          margin-top: 0.625rem !important;
          padding: 0.125rem 1rem 0.625rem 1rem;
        `
      : css``}
`;

const selectStyles = {
  container: base => ({
    ...base,
    minWidth: '80px',
    border: 'none',
    outline: 'none',
    marginBottom: '2px',
  }),
  control: base => ({
    ...base,
    border: 'none',
    outline: 'none',
    borderBottom: '1px solid #949494',
    fontSize: '14px',
    '&:hover': {
      borderBottom: '2px solid #1e2884',
    },
  }),
  option: (base, state) => {
    const color = state.isDisabled ? '#797979' : 'black';
    return {
      ...base,
      color,
      padding: '10px',
      fontSize: '15px',
      cursor: 'pointer',
    };
  },
  indicatorSeparator: base => ({
    ...base,
    display: 'none',
  }),
  singleValue: (base, state) => {
    const opacity = state.isDisabled ? 0.5 : 1;
    const transition = 'opacity 300ms';

    return { ...base, opacity, transition };
  },
};

class SpecificationSheetForm extends React.Component {
  state = {
    rangeLight: false,
    r1: '',
    r2: '',
    selectedMFs: [],
  };

  componentDidMount() {
    if (
      this.props.specSheet.lightSourceColour.criteriaStringForBe.includes('-')
    ) {
      let range = this.props.specSheet.lightSourceColour.criteriaStringForBe.split(
        '-'
      );
      this.setState({
        rangeLight: true,
        r1: range[0],
        r2: range[1],
      });
    }
  }

  handleChangeRange = event => {
    this.setState({ rangeLight: event.target.checked, r1: '', r2: '' }, () => {
      this.props.handleInputChange('lightSourceColourRange', '')(event);
    });
  };

  handleChangeRangeInput = name => event => {
    this.setState({ [name]: event.target.value }, () => {
      let range = this.state.r1 + '-' + this.state.r2;
      this.props.handleInputChange('lightSourceColourRange', range)(event);
    });
  };

  renderCriteria = criteria => {
    if (!this.props.specSheet[criteria]) return;
    return (
      <CriteriaWrapper key={criteria}>
        {this.renderCriteriaName(criteria)}
        {this.renderDropdown(criteria)}
      </CriteriaWrapper>
    );
  };

  renderCriteriaName = criteria => {
    const criteriaId = this.props.specSheet[criteria].criteriaIdForBe;
    const addSpacing =
      criteriaId === 65 ||
      criteriaId === 64 ||
      criteriaId === 261 ||
      criteriaId === 132 ||
      criteriaId === 318;

    return (
      <NameWrapper>
        <Name>{this.props.specSheet[criteria].name + ' :'}</Name>
        {addSpacing && <Spacing />}
      </NameWrapper>
    );
  };

  addInputForSpecificCriteria = (criteria, criteriaName, optionsValue) => {
    if (Array.isArray(criteria.criteriaIdForBe)) {
      if (criteria.criteriaIdForBe.length > 0) {
        if (
          criteria.criteriaIdForBe.find(cr => cr.value === 550) &&
          criteria.criteriaIdForBe.find(cr => cr.value === 551)
        ) {
          return (
            <InputWrapper additional="true">
              <FormControl style={{ width: '100%' }}>
                <InputLabel
                  style={{ fontSize: '14px', padding: '0 0 10px 10px' }}
                  htmlFor="component-simple"
                >
                  You can't select both Other and NEMA enclosure
                </InputLabel>
                <TextInput
                  id="component-simple"
                  value=""
                  onChange={e => this.props.handleInputChange(criteriaName)(e)}
                  onKeyDown={e => {
                    if (e.keyCode === 8) {
                      e.target.value = '';
                      this.props.handleInputChange(criteriaName)(e);
                    }
                  }}
                  disabled="true"
                  fullWidth
                />
              </FormControl>
            </InputWrapper>
          );
        }
        if (
          criteria.criteriaIdForBe.find(cr => cr.value === 550) ||
          criteria.criteriaIdForBe.find(cr => cr.value === 551)
        ) {
          return (
            <InputWrapper additional="true">
              <FormControl style={{ width: '100%' }}>
                <InputLabel
                  style={{ fontSize: '14px', padding: '0 0 10px 10px' }}
                  htmlFor="component-simple"
                >
                  {criteria.criteriaIdForBe.find(cr => cr.value === 550)
                    ? criteria.criteriaIdForBe.filter(cr => cr.value === 550)[0]
                        .label
                    : criteria.criteriaIdForBe.filter(cr => cr.value === 551)[0]
                        .label}
                </InputLabel>
                <TextInput
                  id="component-simple"
                  value={criteria.criteriaStringForBe}
                  onChange={e => this.props.handleInputChange(criteriaName)(e)}
                  onKeyDown={e => {
                    if (e.keyCode === 8) {
                      e.target.value = '';
                      this.props.handleInputChange(criteriaName)(e);
                    }
                  }}
                  disabled={this.props.isDisabled}
                  fullWidth
                />
              </FormControl>
            </InputWrapper>
          );
        }
      }
    } else {
      if (
        criteria.criteriaIdForBe === 65 ||
        criteria.criteriaIdForBe === 66 ||
        criteria.criteriaIdForBe === 64 ||
        criteria.criteriaIdForBe === 261 ||
        criteria.criteriaIdForBe === 132 ||
        criteria.criteriaIdForBe === 318 ||
        criteria.criteriaIdForBe === 425 ||
        criteria.criteriaIdForBe === 572 ||
        criteria.criteriaIdForBe === 568
      ) {
        return (
          <InputWrapper additional="true">
            <TextInput
              value={criteria.criteriaStringForBe}
              onChange={this.props.handleInputChange(criteriaName)}
              fullWidth
              disabled={this.props.isDisabled}
            />
            {criteria.unit && <Unit>{criteria.unit}</Unit>}
          </InputWrapper>
        );
      } else if (criteria.criteriaIdForBe === 319) {
        return (
          <InputWrapper additional="true">
            <Range>
              {!this.state.rangeLight ? (
                <TextInput
                  value={criteria.criteriaStringForBe}
                  onChange={this.props.handleInputChange(criteriaName)}
                  disabled={this.props.isDisabled}
                  fullWidth
                />
              ) : (
                <React.Fragment>
                  <TextInput
                    value={this.state.r1}
                    onChange={this.handleChangeRangeInput('r1')}
                    disabled={this.props.isDisabled}
                    fullWidth
                  />
                  {'-'}
                  <TextInput
                    value={this.state.r2}
                    onChange={this.handleChangeRangeInput('r2')}
                    disabled={this.props.isDisabled}
                    fullWidth
                  />
                </React.Fragment>
              )}
              <RangLabel>Range</RangLabel>
              <Checkbox
                checked={this.state.rangeLight}
                onChange={this.handleChangeRange}
              ></Checkbox>
            </Range>
          </InputWrapper>
        );
      } else if (
        criteria.criteriaIdForBe === 330 ||
        criteria.criteriaIdForBe === 270
      ) {
        // if criteriaIdForBe is 330 return 10 otherwise its 270 and return 68
        var value = criteria.criteriaIdForBe === 330 ? 10 : 68;
        return (
          <InputWrapper additional="true">
            <TextInput
              value={criteria.criteriaStringForBe}
              type="number"
              onChange={e => {
                if (e.target.value <= value && e.target.value > 0) {
                  this.props.handleInputChange(criteriaName)(e);
                }
              }}
              onKeyDown={e => {
                if (e.keyCode === 8) {
                  e.target.value = '';
                  this.props.handleInputChange(criteriaName)(e);
                }
              }}
              disabled={this.props.isDisabled}
              fullWidth
            />
          </InputWrapper>
        );
      } else {
        return;
      }
    }
    criteria.criteriaStringForBe = '';
  };

  renderDropdown = criteriaName => {
    let criteria = this.props.specSheet[criteriaName];
    let id = criteria.id;
    let dropdown = criteria.options;
    let name = criteria.name;
    let optionsValue = [];
    //For Acessoriess:
    var counter = 0;
    const counterForAccDrop = updateCounter => {
      if (updateCounter) {
        counter++;
      }
      return counter;
    };
    //combination(4 criteria list in one), depends from this counter

    const unitDropdownOptions = {
      324: [
        { value: 'W', label: 'W' },
        { value: 'W/m', label: 'W/m' },
        { value: 'W/ft', label: 'W/ft' },
      ],
      325: [
        { value: 'lm', label: 'lm' },
        { value: 'lm/m', label: 'lm/m' },
        { value: 'lm/ft', label: 'lm/ft' },
      ],
    };

    if (!dropdown) {
      return (
        <InputWrapper>
          <TextInput
            disabled={criteria.disabled || this.props.isDisabled}
            value={criteria.criteriaStringForBe}
            onChange={this.props.handleInputChange(criteriaName)}
            fullWidth
          />
          {criteria.unit ? (
            criteria.id === 324 || criteria.id === 325 ? (
              <Select
                isMulti={false}
                isSearchable={false}
                name={name}
                value={[{ value: criteria.unit, label: criteria.unit }]}
                onChange={this.props.handleSelectChange(
                  criteriaName,
                  dropdown,
                  id,
                  criteria
                )}
                options={unitDropdownOptions[criteria.id]}
                styles={selectStyles}
                theme={theme => ({
                  ...theme,
                  borderRadius: 0,
                  colors: {
                    ...theme.colors,
                    primary25: '#e0e0e0',
                    primary: '#e0e0e0',
                  },
                })}
              />
            ) : (
              <Unit>{criteria.unit}</Unit>
            )
          ) : (
            ''
          )}
        </InputWrapper>
      );
    } else {
      const options = [];
      if (dropdown) {
        dropdown.forEach(item => {
          if (id === 7) {
            let help = item.filter(i => i.id !== 382 && i.id !== 99999);
            const combined = this.combineDropdownsForAccessories(
              help,
              counterForAccDrop
            );
            if (Array.isArray(combined[0])) {
              const arrRes = combined.shift();
              combined.unshift(arrRes[1]);
              combined.unshift(arrRes[0]);
            }

            options.push(...combined);
          } else {
            options.push({
              value: item.id,
              label: item.name,
            });
          }
        });
      }
      let work_array = [];
      if (Array.isArray(criteria.criteriaIdForBe)) {
        work_array = criteria.criteriaIdForBe;
      } else {
        work_array = options.filter(
          option => option.value === criteria.criteriaIdForBe
        );
      }
      if (id === 7) {
        if (work_array.length > 0) {
          const unique = work_array.filter((data, index) => {
            const _data = JSON.stringify(data);
            return (
              index ===
              work_array.findIndex(obj => {
                return JSON.stringify(obj) === _data;
              })
            );
          });
          optionsValue = unique;
        } else {
          let helper = [];
          // this.props.accessories.forEach((item, index) => {
          //   helper.push({ value: item.criteriaId});
          // });
          optionsValue = helper;
        }
        options.unshift({ value: 382, label: 'N/A' });
      } else {
        optionsValue = work_array;
      }
      return (
        <SelectWrapper>
          <Select
            isMulti={id === 7 ? true : false}
            isSearchable={id === 7 ? true : false}
            name={name}
            value={optionsValue}
            onChange={this.props.handleSelectChange(
              criteriaName,
              dropdown,
              id,
              criteria
            )}
            options={options}
            styles={selectStyles}
            theme={theme => ({
              ...theme,
              borderRadius: 0,
              colors: {
                ...theme.colors,
                primary25: '#e0e0e0',
                primary: '#e0e0e0',
              },
            })}
            isDisabled={this.props.isDisabled}
          />
          {this.addInputForSpecificCriteria(
            criteria,
            criteriaName,
            optionsValue
          )}
        </SelectWrapper>
      );
    }
  };

  combineDropdownsForAccessories = (item, counterForAccDrop) => {
    return item.map((x, index) => {
      if (index === 0) {
        if (counterForAccDrop(false) === 0) {
          counterForAccDrop(true);
          return [
            {
              value: 'Lenses',
              label: 'Lenses',
              isDisabled: true,
            },
            {
              value: x.id,
              label: x.name,
            },
          ];
        }
        if (counterForAccDrop(false) === 1) {
          counterForAccDrop(true);
          return [
            {
              value: 'Filters',
              label: 'Filters',
              isDisabled: true,
            },
            {
              value: x.id,
              label: x.name,
            },
          ];
        }
        if (counterForAccDrop(false) === 2) {
          counterForAccDrop(true);
          return [
            {
              value: 'Beam Control',
              label: 'Beam Control',
              isDisabled: true,
            },
            {
              value: x.id,
              label: x.name,
            },
          ];
        }
        if (counterForAccDrop(false) === 3) {
          counterForAccDrop(true);
          return [
            {
              value: 'Glare Control',
              label: 'Glare Control',
              isDisabled: true,
            },
            {
              value: x.id,
              label: x.name,
            },
          ];
        }
        if (counterForAccDrop(false) === 4) {
          counterForAccDrop(true);
          return [
            {
              value: 'Mounting Accessories',
              label: 'Mounting Accessories',
              isDisabled: true,
            },
            {
              value: x.id,
              label: x.name,
            },
          ];
        }
      } else {
        if (x.id !== 99999) {
          return {
            value: x.id,
            label: x.name,
          };
        }
      }
    });
  };
  render() {
    return (
      <PaperGrid container spacing={16} paperstyle={this.props.paperstyle}>
        <Column item md={6} xs={12}>
          {this.props.leftSide.map(this.renderCriteria)}
        </Column>
        <Column item md={6} xs={12}>
          {this.props.rightSide.map(this.renderCriteria)}
        </Column>
      </PaperGrid>
    );
  }
}

export default SpecificationSheetForm;
